import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=0639f13a&scoped=true&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639f13a",
  null
  
)

export default component.exports